import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function getAuth() {
  return Cookies.get('user_auth')
}
export function setAuth(arr) {
  return Cookies.set('user_auth', arr)
}
export function removeAuth() {
  return Cookies.remove('user_auth')
}
